import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SimpleUserStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M7.40923 15.0547C10.3481 13.6014 13.9804 13.65 16.8731 15.2002L17.3672 15.4531C17.9564 15.7535 18.7782 16.1888 19.3565 16.6982C19.7447 17.0403 20.1603 17.5286 20.2374 18.1621C20.3111 18.7693 20.0571 19.3131 19.6016 19.7744L19.3946 19.9668C18.3997 20.8199 17.2072 21.5 15.6739 21.5H8.32622C6.98453 21.5 5.90396 20.9791 4.98833 20.2773L4.60552 19.9668C4.02248 19.4669 3.67847 18.8559 3.76274 18.1621C3.83976 17.5286 4.2554 17.0403 4.6436 16.6982C5.41467 16.019 6.61874 15.4726 7.127 15.2002L7.40923 15.0547ZM16.1641 16.5225C13.7003 15.2022 10.581 15.1606 8.07622 16.3984L7.83599 16.5225C7.16522 16.8819 6.23336 17.296 5.63482 17.8232C5.33866 18.0841 5.26112 18.2607 5.25103 18.3428C5.24838 18.3645 5.22382 18.5209 5.58208 18.8281L5.89946 19.0859C6.64357 19.6569 7.41405 20 8.32622 20H15.6739C16.7162 20 17.5735 19.5522 18.418 18.8281L18.5352 18.7197C18.7703 18.4838 18.7514 18.3618 18.7491 18.3428C18.739 18.2607 18.6615 18.0842 18.3653 17.8232C17.9163 17.4277 17.28 17.0957 16.7071 16.8027L16.1641 16.5225ZM15.25 7.25C15.25 5.45508 13.7949 4 12 4C10.2051 4 8.75005 5.45507 8.75005 7.25C8.75005 9.04493 10.2051 10.5 12 10.5C13.7949 10.5 15.25 9.04492 15.25 7.25ZM16.75 7.25C16.75 9.87336 14.6234 12 12 12C9.3767 12 7.25005 9.87335 7.25005 7.25C7.25005 4.62665 9.3767 2.5 12 2.5C14.6234 2.5 16.75 4.62664 16.75 7.25Z"
				fill="currentColor"
			/>
		</svg>
	);
}

SimpleUserStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SimpleUserStrokeIcon;
